import React, { Component } from "react";
import { Navbar, NavbarBrand } from "reactstrap";

class AgendaNavBar extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <Navbar color="faded" light expand="md">
        <NavbarBrand href="http://metz.fr">
          <span style={{ fontSize: "24px", color: "white" }}>metz.fr</span>
        </NavbarBrand>
      </Navbar>
    );
  }
}

export default AgendaNavBar;



// WEBPACK FOOTER //
// ./src/AgendaNavBar.jsx